import { DataModel } from '../../dto/dto.js';
import { InvoiceProvider } from './invoice-provider.js';

export abstract class InvoicingProtocol extends DataModel {
  abstract get provider(): InvoiceProvider;
  abstract get allowLegalEntities(): boolean;
}
